(function () {
  const storageKey = "greez_attribution";
  const legacySourceKey = "greez_attribution_source";
  const config = window.greezAttributionConfig || {};

  function normalize(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[\s_]+/g, "-");
  }

  function getPaidSources() {
    if (Array.isArray(config.paidSources)) {
      return config.paidSources.map(normalize).filter(Boolean);
    }
    return [];
  }

  function readStoredAttribution() {
    try {
      const stored = window.localStorage.getItem(storageKey);
      if (stored) return JSON.parse(stored);

      const legacySource = window.localStorage.getItem(legacySourceKey);
      if (legacySource) return { source: legacySource };
    } catch (error) {
      return null;
    }

    return null;
  }

  function writeStoredAttribution(attribution) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(attribution));
      if (attribution.source) {
        window.localStorage.setItem(legacySourceKey, attribution.source);
      }
    } catch (error) {
      return;
    }
  }

  function getClickId(params) {
    const clickIdKeys = ["gclid", "gbraid", "wbraid", "fbclid", "ttclid", "msclkid"];

    for (const key of clickIdKeys) {
      const value = params.get(key);
      if (value) return { key, value };
    }

    return null;
  }

  function hasPaidSignal(attribution) {
    const paidSources = getPaidSources();
    const source = normalize(attribution && attribution.source);
    const medium = normalize(attribution && attribution.medium);

    if (attribution && attribution.clickIdKey) return true;
    if (source && paidSources.includes(source)) return true;
    if (source === "google" && medium === "shopping") return true;

    return ["paid", "paid-social", "cpc", "ppc", "display", "shopping", "retargeting"].includes(medium);
  }

  function captureFromUrl() {
    if (!config.enabled) return null;

    const params = new URLSearchParams(window.location.search);
    const clickId = getClickId(params);
    const source = params.get("utm_source");
    const medium = params.get("utm_medium");
    const campaign = params.get("utm_campaign");

    if (!source && !medium && !campaign && !clickId) return readStoredAttribution();

    const attribution = {
      source: source || (clickId ? clickId.key.replace("clid", "") : ""),
      medium: medium || "",
      campaign: campaign || "",
      content: params.get("utm_content") || "",
      term: params.get("utm_term") || "",
      clickIdKey: clickId ? clickId.key : "",
      capturedAt: new Date().toISOString(),
      landingPath: window.location.pathname + window.location.search,
    };

    attribution.isPaid = hasPaidSignal(attribution);
    writeStoredAttribution(attribution);
    syncCartAttributes(attribution);

    return attribution;
  }

  function syncCartAttributes(attribution) {
    if (!attribution || !config.cartUpdateUrl) return;

    const payload = {
      attributes: {
        "__traffic_source": attribution.source || "",
        "__traffic_medium": attribution.medium || "",
        "__traffic_campaign": attribution.campaign || "",
        "__traffic_click_id": attribution.clickIdKey || "",
        "__traffic_origin": attribution.isPaid ? "paid" : "organic",
      },
    };

    window
      .fetch(config.cartUpdateUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        credentials: "same-origin",
      })
      .catch(function () {});
  }

  function getAttribution() {
    return readStoredAttribution();
  }

  window.GreezAttribution = {
    capture: captureFromUrl,
    get: getAttribution,
    isPaidTraffic: function () {
      const attribution = getAttribution();
      return Boolean(attribution && (attribution.isPaid || hasPaidSignal(attribution)));
    },
    shouldOverrideCartDrawerCta: function () {
      return Boolean(config.cartDrawerOverrideEnabled && this.isPaidTraffic());
    },
    getCartDrawerOverrideDestination: function () {
      return config.cartDrawerOverrideDestination || "checkout";
    },
  };

  captureFromUrl();
})();
